// Mirrors the backend InvitationType enum, serialized as a string.
const INVITATION_TYPES = {
  MEMBERSHIP: 'Membership',
  PASS_OWNERSHIP: 'PassOwnership',
  KICKOFF: 'Kickoff',
}

export default INVITATION_TYPES
